if (!customElements.get('ap-newsletter-bar')) {
  customElements.define('ap-newsletter-bar', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const storageKey = 'ap-newsletter-bar-dismissed-v1';
      const designMode = this.dataset.designMode === 'true';
      const restoreDismissal = () => {
        try {
          if (!designMode && sessionStorage.getItem(storageKey) === '1') this.hidden = true;
        } catch {}
      };
      restoreDismissal();
      const closeButton = this.querySelector('.ap-newsletter-bar__close');
      if (closeButton) {
        closeButton.hidden = false;
        closeButton.addEventListener('click', () => {
          this.hidden = true;
          try {
            if (!designMode) sessionStorage.setItem(storageKey, '1');
          } catch {}
        }, { signal });
      }
      window.addEventListener('pageshow', restoreDismissal, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
